import type { AdaptiveCardSchema } from '@/lib/adaptive-card'
import type { ComposerTranslation } from 'vue-i18n'

export const CHAT_ERROR_RETRY_TEMPLATE_ID = 'chat.error.retry.v1'
export const CHAT_RETRY_LAST_TURN_ACTION = 'chat.retry_last_turn'
export const CHAT_START_NEW_ACTION = 'chat.start_new'
export const CHAT_RESUME_ACTION = 'chat.resume'
export const CHAT_OPEN_SETTINGS_ACTION = 'chat.open_settings'

const templateModules = import.meta.glob<{ default: AdaptiveCardSchema }>(
  './message-templates/*.json',
  { eager: true },
)

const templatesById = Object.fromEntries(
  Object.entries(templateModules).map(([path, module]) => {
    const fileName = path.split('/').pop() ?? ''
    const templateId = fileName.replace(/\.json$/, '')
    return [templateId, module.default]
  }),
) as Record<string, AdaptiveCardSchema>

export function resolveMessageTemplate(templateId: string): AdaptiveCardSchema | null {
  return templatesById[templateId] ?? null
}

export function resolveTemplateData(
  templateId: string | undefined,
  data: Record<string, unknown> | undefined,
  t: ComposerTranslation,
): Record<string, unknown> | undefined {
  const resolved: Record<string, unknown> = { ...(data ?? {}) }
  switch (templateId) {
    case CHAT_ERROR_RETRY_TEMPLATE_ID:
      if (typeof resolved.retryLabel !== 'string') {
        resolved.retryLabel = t('actions.retry')
      }
      break
    default:
      break
  }
  return Object.keys(resolved).length ? resolved : undefined
}
